export default "__VITE_ASSET__0a09bdca__"